import { Box, Grid, Typography } from "@mui/material";
import EngineerTestimonialCard from "./EngineerTestimonialCard";
import { engineerTestimonials } from "../../data/engineerTestimonials";
import useResponsiveSpacingGrid from "../../hooks/useResponsiveSpacingGrid";

const EngineerTestimonials: React.FC = () => {
  const spacing = useResponsiveSpacingGrid();
  return (
    <Box
      component="section"
      sx={{
        pt: { xs: 2, sm: 2 },
        mt: { xs: 6, sm: 6, md: 8, lg: 10 },
        mb: { xs: 2, sm: 8 },
        px: { xs: 3, sm: 4 },
        mx: "auto",
        maxWidth: "1100px",
      }}
    >
      <Typography
        variant="h3"
        align="left"
        fontWeight="bold"
        gutterBottom
        sx={{ mb: { xs: 4, sm: 6, md: 6 } }}
      >
        {engineerTestimonials.title}
      </Typography>
      <Grid container spacing={spacing} justifyContent="center">
        {engineerTestimonials.sections.map((testimonial, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
            <EngineerTestimonialCard testimonial={testimonial} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EngineerTestimonials;
